import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { constants, endpoint } from 'src/environments/environment';
import { CacheService } from './cache.service';
import listLogMessages from 'src/app/core/constants/transaction-log-messages/transaction-log-messages.json';

@Injectable({
  providedIn: 'root'
})
export class BlockModuleService {

  private showModalSubjet = new Subject<void>()
  idBlockModule = constants.idBlockModule
  listLogMessages: typeof listLogMessages = listLogMessages
  showModal$ = this.showModalSubjet.asObservable()

  url: string = endpoint.apiUrl + endpoint.apiRoute + endpoint.blockModule
  private httpCLient = inject(HttpClient)
  private cacheService = inject(CacheService)
  
  getInfoBlockModule<T>(): Observable<T> {
    const transactionLog = {
    idBlock: this.idBlockModule,
     log:  {
      identificationNumber: this.cacheService.get('documentClient'),
      identificationType: this.cacheService.get("typeDocumentClient"),
      ipTransaction: this.cacheService.get('ip') || '',
      idSession: this.cacheService.get('idSession'),
      idRequest: 'blockModule',
      description: this.listLogMessages.blockModule
    }
    }
    const log = {
      identificationNumber: this.cacheService.get('documentClient'),
      identificationType: this.cacheService.get("typeDocumentClient"),
      ipTransaction: this.cacheService.get('ip') || '',
      idSession: this.cacheService.get('idSession'),
      idRequest: 'blockModule',
      description: this.listLogMessages.blockModule
    }
    return this.httpCLient.post<T>(`${this.url}?id_block=${this.idBlockModule}`, transactionLog)
  }

  openModal(): void {
    this.showModalSubjet.next()
  }
}
